import { addressToString } from '@elements/address-utils';
import { trans } from '@elements/translation';
import OFFICE_STATE from '@organisms/offer/office-state-enum';
import OfficeTypeEnum from '@organisms/offer/office-type-enum';
import moment from 'moment';
import OfficeStateEnum from './office-state-enum';
import 'moment/dist/locale/fr';

moment.locale('fr');

const isBefore = (date, dateToCompare) => {
  if (!date || !dateToCompare) {
    return null;
  }
  return moment(date).isBefore(moment(dateToCompare));
};

export const HEADER_TABLE_LIST = [
  {
    title: 'offer.address.name',
    fieldName: 'address.name',
    formatted: (offer) => {
      if (!offer.address) {
        return '';
      }

      if (offer.address.name === '') {
        return addressToString(offer.address);
      }

      return offer.address.name;
    },
  },
  {
    title: 'offer.name',
    fieldName: 'name',
    classes: 'header-link',
  },
  {
    title: 'offer.office_type',
    fieldName: 'office_type.name',
  },
  {
    title: 'offer.floor',
    fieldName: 'floor',
    formatted: (offer) => {
      if (offer.floor > 0) {
        return `R+${offer.floor}`;
      }

      if (offer.floor < 0) {
        return `R${offer.floor}`;
      }

      return 'RDC';
    },
  },
  {
    title: 'offer.capacity_count',
    fieldName: 'capacity',
    classes: 'header-capacity',
  },
  {
    title: 'offer.surface',
    fieldName: 'surface',
    formatted: (offer) => {
      if (!offer.office_type) {
        return '';
      }

      if (offer.office_type.code === OfficeTypeEnum.OPEN_SPACE) {
        return '-';
      }

      return `${offer.surface} ${trans('global.area_unit.MTK')}`;
    },
    classes: 'header-surface',
  },
  {
    title: 'offer.price',
    fieldName: 'price',
    formatted: (offer) => offer.price.toLocaleString('fr-FR'),
    classes: 'header-price',
    editable: true,
  },
  {
    title: 'offer.state',
    fieldName: 'state',
    classes: 'header-state',
    editable: true,
  },
  {
    title: 'offer.availability_date',
    fieldName: 'availability_date',
    formatted: (offer) => {
      if (offer.availability_date === null) {
        return '-';
      }

      if (moment(offer.availability_date.iso).isSame(moment(), 'day') || isBefore(offer.availability_date.iso, moment())) {
        return trans('offer.availability_now');
      }

      return offer.availability_date ? moment(offer.availability_date.iso).format('DD/MM/YYYY') : '';
    },
    editable: true,
  },
  {
    title: 'offer.actions',
    fieldName: 'actions',
    classes: 'header-actions',
  },
];

export const isOfferDisabled = (offer) => ![ OfficeStateEnum.PUBLISHED, OfficeStateEnum.OFFMARKET ].includes(offer.state);

export const getSellerOfferUrl = (offer) => {
  if (offer.published) {
    return offer.public_url;
  }

  if (OFFICE_STATE.DRAFT_LOOK_ALIKE.includes(offer.state)) {
    return offer.edit_url;
  }

  return offer.private_url;
};
